<template>
  <v-dialog @click:outside="closeModal()" v-model="dialog" max-width="700">
    <div class="vpd-confirm-dialog">
      <h2 class="vpd-confirm-dialog-title">
        {{ headline }}
      </h2>
      <div class="vpd-confirm-dialog-subtitle">
        {{ subtitle }}
      </div>
      <div v-if="bankId && schema" justify="center">
        <v-col cols="12" class="pa-0 col-dense d-flex justify-center">
          <FormulateForm name="bankForm" ref="bankForm" v-model="values" :schema="schema"
            @validation="validation = $event" @blur="displayFormInputFields">
            <div class="actions-button-container">
              <div class="vpd-dialog-confirm-button-container">
                <div class="confirm-button" @click="handleSubmit($event, values)">
                  <span v-if="!loading">rendben</span>
                  <img v-else :src="loaderIcon" class="spin" alt="Töltés" style="height:24px;" />
                </div>
              </div>
            </div>
          </FormulateForm>
        </v-col>
      </div>
      <div class="actions-button-container" v-if="this.schema == null">
        <div class="vpd-dialog-confirm-button-container">
          <div class="confirm-button" @click="handleSubmit($event, values)">
            <span v-if="!loading">rendben</span>
            <img v-else :src="loaderIcon" class="spin" alt="Töltés" style="height:24px;" />
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import "./_vpd-confirm-dialog.scss";

export default {
  name: "vpd-confirm-dialog",
  methods: {
    displayFormInputFields() {
      if (this.values?.iban) {
        this.values.iban = this.values.iban.replace(/[^0-9]/g, '');

        if (this.values.iban?.length == 16) {
          this.values.iban = this.values.iban.substring(0, 8) + "-" + this.values.iban.substring(8) + "-00000000";
        }

        if (this.values.iban?.length == 24) {
          this.values.iban = this.values.iban.substring(0, 8) + "-" + this.values.iban.substring(8, 16) + "-" + this.values.iban.substring(16);
        }
      }

      if (this.values?.currency) {
        this.values.currency = this.values.currency.toUpperCase();
      }
    },
    async handleSubmit(domEvent, values) {
      if (this.$refs.bankForm) {
        const hasErrors = await this.$refs.bankForm.hasValidationErrors(); // ADD AWAIT HERE

        if (hasErrors) {
          await this.$refs.bankForm.showErrors();
          return;
        }
      }

      this.$emit(this.event, values);

      if (this.$refs.bankForm) {
        this.$formulate.reset('bankForm');
      }
    },
    closeModal() {
      if (this.schema !== null) {
        this.$formulate.reset('bankForm');
      }
      this.$emit('close-modal');
    }
  },
  props: {
    headline: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
    },
    dialog: {
      type: Boolean,
      required: true,
    },
    event: {
      type: String,
      required: true,
    },
    bankId: {
      type: String,
      required: false,
    },
    schema: {
      type: Array,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
    }
  },
  data: function () {
    return {
      values: {},
      validation: {},
    }
  },
};
</script>
